module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"reportButton":"Lataa velkatiedot (pdf)","balanceReport":"Saldoraportti"},"se":{"reportButton":"Ladda ner skuldinformation (pdf)","balanceReport":"Saldorapport"},"en":{"reportButton":"Download debt information (pdf)","balanceReport":"Balancereport"}}')
  delete Component.options._Ctor
}
